import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import { questions } from "../data/questions";
import { useTestSession } from "../context/TestSessionContext";

function TestPage() {
  const navigate = useNavigate();
  const { answers, startTest, setAnswer } = useTestSession();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (answers.length === 0) {
      startTest(questions.length);
      setCurrentIndex(0);
    }
  }, [answers.length, startTest]);

  const total = questions.length;
  const currentQuestion = questions[currentIndex];
  const selected = answers[currentIndex];
  const answeredCount = answers.filter(Boolean).length;
  const progress = Math.round((answeredCount / total) * 100);

  const handlePick = (option) => {
    setAnswer(currentIndex, option);
    if (currentIndex === total - 1) {
      navigate("/result");
      return;
    }
    setCurrentIndex((prev) => prev + 1);
  };

  const handlePrev = () => {
    if (currentIndex === 0) return;
    setCurrentIndex((prev) => prev - 1);
  };

  return (
    <main className="min-h-screen bg-gray-50 px-4 py-8 text-gray-900 md:px-6">
      <section className="mx-auto max-w-3xl rounded-2xl bg-white p-6 shadow-lg md:p-8">
        <ProgressBar
          current={currentIndex + 1}
          total={total}
          percent={progress}
        />

        <h2 className="mb-5 text-2xl font-bold">{currentQuestion.text}</h2>
        <div className="space-y-3">
          {currentQuestion.options.map((option) => {
            const isSelected = selected?.label === option.label;
            return (
              <button
                key={option.label}
                onClick={() => handlePick(option)}
                className={`w-full rounded-xl border p-4 text-left transition ${
                  isSelected
                    ? "border-fox-orange bg-orange-50"
                    : "border-gray-200 hover:border-orange-300 hover:bg-orange-50/60"
                }`}
              >
                {option.label}
              </button>
            );
          })}
        </div>

        <div className="mt-6 flex items-center gap-3">
          <button
            onClick={handlePrev}
            disabled={currentIndex === 0}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            上一题
          </button>
          <button
            onClick={() => navigate("/")}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            返回首页
          </button>
        </div>
      </section>
    </main>
  );
}

export default TestPage;
